module.exports = require('crypto');


// WEBPACK FOOTER //
// ./node_modules/web3/packages/web3-utils/node_modules/randomhex/src/crypto.js